import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SvgComponent } from '@components/svg.component';
import { TerminalUserPermissionsComponent } from '@components/terminal-user-permissions/terminal-user-permissions.component';
import { HistoryService } from '@services/history.service';

export type AdminSettingsSectionKey = 'terminal-permissions';

interface AdminSettingsSection {
  key: AdminSettingsSectionKey;
  labelKey: string;
  titleKey: string;
  descriptionKey: string;
}

@Component({
  selector: 'app-admin-settings-page',
  imports: [TranslateModule, SvgComponent, TerminalUserPermissionsComponent],
  templateUrl: './admin-settings-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { class: 'block h-full' },
})
export class AdminSettingsPageComponent {
  private readonly historyService = inject(HistoryService);

  protected readonly sections: AdminSettingsSection[] = [
    {
      key: 'terminal-permissions',
      labelKey: 'admin_settings.sections.terminal_permissions',
      titleKey: 'admin_settings.terminal_permissions.title',
      descriptionKey: 'admin_settings.terminal_permissions.description',
    },
  ];

  protected readonly activeSection = signal<AdminSettingsSectionKey>('terminal-permissions');

  protected readonly activeSectionData = computed(
    () => this.sections.find((section) => section.key === this.activeSection()) ?? null,
  );

  goBack(): void {
    this.historyService.back();
  }

  selectSection(key: AdminSettingsSectionKey): void {
    this.activeSection.set(key);
  }
}
